module.exports = __webpack_public_path__ + "static/fonts/UTM_Ambrosia.103f8f7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/UTM_Ambrosia.ttf
// module id = bMlu
// module chunks = 1